// extracted by mini-css-extract-plugin
export default {"container":"CategoryInfo_container__zRNF0"};